module.exports = __webpack_public_path__ + "img/menu-Manage.bf975310.svg";